import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  ICreateAssetBrandsRequest,
  IGetAssetBrandsByIdRequest,
  IUpdateAssetBrandsRequest,
  TGetAssetBrandsRequest,
  TGetAssetBrandsResponse,
  TSingleAssetBrandsResponse,
} from "@/types/(company)/assetBrands.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyAssetBrandsApi = createApi({
  reducerPath: "companyAssetBrandsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getAssetBrands"],
  endpoints: (builder) => ({
    getAssetBrands: builder.query<
      TGetAssetBrandsResponse,
      TGetAssetBrandsRequest
    >({
      query: () => {
        return {
          url: "/company/brands/all",
          method: "GET",
        };
      },
      providesTags: ["getAssetBrands"],
    }),
    createAssetBrands: builder.mutation<
      TSingleAssetBrandsResponse,
      ICreateAssetBrandsRequest
    >({
      query: (body) => {
        return {
          url: "/company/brands",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["getAssetBrands"],
    }),
    getAssetBrandsById: builder.query<
      TSingleAssetBrandsResponse,
      IGetAssetBrandsByIdRequest
    >({
      query: (param) => {
        return {
          url: "/company/brands/" + param.id,
          method: "GET",
        };
      },
      providesTags: ["getAssetBrands"],
    }),
    updateAssetBrands: builder.mutation<
      TSingleAssetBrandsResponse,
      IUpdateAssetBrandsRequest
    >({
      query: ({ id, ...body }) => {
        return {
          url: "/company/brands/" + id,
          method: "PUT",
          body: body.data,
        };
      },
      invalidatesTags: ["getAssetBrands"],
    }),
    deleteAssetBrands: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: "/company/brands/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["getAssetBrands"],
    }),
  }),
});

export const {
  useGetAssetBrandsQuery,
  useCreateAssetBrandsMutation,
  useGetAssetBrandsByIdQuery,
  useUpdateAssetBrandsMutation,
  useDeleteAssetBrandsMutation,
} = companyAssetBrandsApi;
